import { createTheme, responsiveFontSizes, Theme } from '@mui/material/styles'
import { breakpoints, components, typography as customTypography, palette } from './options'
import WayshrineThemeProvider from './WayshrineThemeProvider'

let theme: Theme = createTheme({
  breakpoints,
  palette,
})

// Override the theme with the customized typography options
theme = createTheme(theme, {
  typography: customTypography(theme.palette, theme.breakpoints),
})

// Override the theme with the customized components. This needs to be done after the typography override so that
// the typography overrides are applied to the components
theme = createTheme(theme, {
  components: components,
})

// Make the font sizes responsive
theme = responsiveFontSizes(theme)

export { WayshrineThemeProvider }

export default theme
